import './Hero.css';

function Hero({ onOpenModal }) {
  const handleCapture = (e) => {
    const btn = e.currentTarget;
    btn.textContent   = "✓ We'll call you!";
    btn.style.background = '#1B6B47';
    btn.style.color      = '#fff';
  };

  return (
    <section className="hero">
      {/* Animated background lines */}
      <div className="hero-lines">
        <span /><span /><span /><span /><span />
      </div>

      {/* Gold glow */}
      <div className="hero-glow" />

      {/* LEFT */}
      <div className="hero-left">
        <div className="h-tag">
          <span />
          Strategic Financial Advisor
        </div>

        <h1>
          Tax-Free.<br />
          Protected.<br />
          <span className="outline">Generational.</span>
        </h1>

        <p className="hero-desc">
          Roth conversions, MSO structures, life insurance strategies tax-free, annuities,
          and trust or will planning — built for high-income individuals who want to keep
          more of what they earn.
        </p>

        <div className="hero-capture">
          <input type="email" placeholder="Your email address" />
          <button onClick={handleCapture}>Book a Call</button>
        </div>

        <div className="h-note">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          Confidential consultation. No obligation.
        </div>
      </div>

      {/* RIGHT — stat cards */}
      <div className="hero-right">
        <div className="hstat">
          <div className="hstat-num" data-target="300" data-suffix="K">0</div>
          <div className="hstat-label">Long-term care dollars from $100K qualified money</div>
        </div>

        <div className="hstat">
          <div className="hstat-num" data-target="0" data-suffix="%">—</div>
          <div className="hstat-label">Future taxes on Roth conversions done right</div>
        </div>

        <div className="hstat">
          <div className="hstat-num" data-target="16" data-suffix="%">0</div>
          <div className="hstat-label">Estate value lost to probate — avoidable with a trust</div>
        </div>

        <div className="hstat span2">
          <div className="hstat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <div>
            <div className="hstat-num" style={{ fontSize: '24px' }}>
              Don't Use It,<br />Don't Lose It.
            </div>
            <div className="hstat-label" style={{ marginTop: '4px' }}>
              Lifetime care coverage with a rider. Full policy value passes to beneficiaries if unused.
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="scroll-cue">
        <div className="scroll-cue-line" />
        Scroll
      </div>
    </section>
  );
}

export default Hero;
